import type { Appointment, CalendarTask } from '@kontor/shared';

/**
 * Ein Eintrag im Kalender: ein Termin oder eine Aufgabe (KON-087). Aufgaben erscheinen wie ganztägige Termine von ihrem ersten bis zum letzten Tag, mit Häkchen-Symbol
 * und in der Farbe ihres Aufgabentyps. Alles Weitere (Farben, Raster, Liste) behandelt beide gleich, nur der Verweis und die Beschriftung unterscheiden sich.
 */
export type CalItem = Appointment & { kind?: 'task'; done?: boolean; assignedUserId?: string | null };

export function taskToItem(t: CalendarTask): CalItem {
  return {
    id: t.id,
    title: t.title,
    description: null,
    location: null,
    allDay: true,
    typeId: t.typeId,
    start: t.start,
    end: t.end,
    participantUserIds: t.participantUserIds,
    createdAt: '',
    updatedAt: '',
    editable: false,
    createdByUserId: null,
    assignedUserId: t.assignedUserId,
    masked: false,
    sharedByUserIds: [],
    kind: 'task',
    done: t.status === 'done',
  };
}

export const itemHref = (a: CalItem): string => (a.kind === 'task' ? `/kalender/aufgaben/${a.id}` : `/kalender/termine/${a.id}`);

/**
 * Wem ein Eintrag gehört (KON-117): bei Aufgaben die zuständige Person, bei Terminen der erste Teilnehmer, sonst wer ihn eingetragen hat, bei freigegebenen
 * Terminen der Kollege, der freigegeben hat. `more` zählt weitere Teilnehmer.
 */
export function ownerOf(a: CalItem): { userId: string | null; more: number } {
  if (a.kind === 'task') return { userId: a.assignedUserId ?? null, more: 0 };
  if (a.masked) return { userId: a.sharedByUserIds[0] ?? null, more: 0 };
  if (a.participantUserIds.length > 0) return { userId: a.participantUserIds[0]!, more: a.participantUserIds.length - 1 };
  return { userId: a.createdByUserId, more: 0 };
}

/** Vorsatz vor dem Titel eines Aufgabeneintrags: ☑ erledigt, ☐ offen */
export const taskMark = (a: CalItem): string => (a.kind === 'task' ? (a.done ? '☑ ' : '☐ ') : '');
